export const icones = {
  dashboard: "ph-fill ph-house",
  estoque: "ph-fill ph-shopping-cart",
  faturamento: "ph-fill ph-wallet",
  financeiro: "ph-fill ph-money",
  fiscal: "ph-fill ph-calculator",
  integracao: "ph-fill ph-users",
  "painel-controle": "ph-fill ph-gear",
  pdv: "ph-fill ph-storefront",
  servicos: "ph-fill ph-wrench",
  relatorios: "ph-bold ph-chart-line-up",
};

export const dicionario = {
  "empresas-cadastrar": "cadastrar empresas",
  "empresas-visualizar": "visualizar empresas",
  "empresas-editar": "editar empresas",
  "empresas-excluir": "excluir empresas",
  "usuarios-cadastrar": "cadastrar usuarios",
  "usuarios-visualizar": "visualizar usuarios",
  "usuarios-editar": "editar usuarios",
  "usuarios-excluir": "excluir usuarios",
  "perfis-usuarios-cadastrar": "cadastrar perfis-usuarios",
  "perfis-usuarios-visualizar": "visualizar perfis-usuarios",
  "perfis-usuarios-editar": "editar perfis-usuarios",
  "perfis-usuarios-excluir": "excluir perfis-usuarios",
  "configuracoes-cadastrar": "cadastrar configuracoes",
  "configuracoes-visualizar": "visualizar configuracoes",
  "configuracoes-editar": "editar configuracoes",
  "configuracoes-excluir": "excluir configuracoes",
  "pessoas-cadastrar": "cadastrar pessoas",
  "pessoas-visualizar": "visualizar pessoas",
  "pessoas-editar": "editar pessoas",
  "pessoas-excluir": "excluir pessoas",
  "grupo-pessoas-cadastrar": "cadastrar grupo-pessoas",
  "grupo-pessoas-visualizar": "visualizar grupo-pessoas",
  "grupo-pessoas-editar": "editar grupo-pessoas",
  "grupo-pessoas-excluir": "excluir grupo-pessoas",
  "produtos-cadastrar": "cadastrar produtos",
  "produtos-visualizar": "visualizar produtos",
  "produtos-editar": "editar produtos",
  "produtos-excluir": "excluir produtos",
  "grupo-produtos-cadastrar": "cadastrar grupo-produtos",
  "grupo-produtos-visualizar": "visualizar grupo-produtos",
  "grupo-produtos-editar": "editar grupo-produtos",
  "grupo-produtos-excluir": "excluir grupo-produtos",
  "modelos-grade-cadastrar": "cadastrar modelos-grade",
  "modelos-grade-visualizar": "visualizar modelos-grade",
  "modelos-grade-editar": "editar modelos-grade",
  "modelos-grade-excluir": "excluir modelos-grade",
  "tabelas-preco-cadastrar": "cadastrar tabelas-preco",
  "tabelas-preco-visualizar": "visualizar tabelas-preco",
  "tabelas-preco-editar": "editar tabelas-preco",
  "tabelas-preco-excluir": "excluir tabelas-preco",
  "regras-desconto-cadastrar": "cadastrar regras-desconto",
  "regras-desconto-visualizar": "visualizar regras-desconto",
  "regras-desconto-editar": "editar regras-desconto",
  "regras-desconto-excluir": "excluir regras-desconto",
  "meios-pagamento-cadastrar": "cadastrar meios-pagamento",
  "meios-pagamento-visualizar": "visualizar meios-pagamento",
  "meios-pagamento-editar": "editar meios-pagamento",
  "meios-pagamento-excluir": "excluir meios-pagamento",
  "condicoes-pagamento-cadastrar": "cadastrar condicoes-pagamento",
  "condicoes-pagamento-visualizar": "visualizar condicoes-pagamento",
  "condicoes-pagamento-editar": "editar condicoes-pagamento",
  "condicoes-pagamento-excluir": "excluir condicoes-pagamento",
  "centro-custo-cadastrar": "cadastrar centro-custo",
  "centro-custo-visualizar": "visualizar centro-custo",
  "centro-custo-editar": "editar centro-custo",
  "centro-custo-excluir": "excluir centro-custo",
  "planos-financeiros-cadastrar": "cadastrar planos-financeiros",
  "planos-financeiros-visualizar": "visualizar planos-financeiros",
  "planos-financeiros-editar": "editar planos-financeiros",
  "planos-financeiros-excluir": "excluir planos-financeiros",
  "classificacoes-financeiras-cadastrar":
    "cadastrar classificacoes-financeiras",
  "classificacoes-financeiras-visualizar":
    "visualizar classificacoes-financeiras",
  "classificacoes-financeiras-editar": "editar classificacoes-financeiras",
  "classificacoes-financeiras-excluir": "excluir classificacoes-financeiras",
  "bancos-caixas-cadastrar": "cadastrar bancos-caixas",
  "bancos-caixas-visualizar": "visualizar bancos-caixas",
  "bancos-caixas-editar": "editar bancos-caixas",
  "bancos-caixas-excluir": "excluir bancos-caixas",
  "caixa-cadastrar": "cadastrar caixa",
  "caixa-visualizar": "visualizar caixa",
  "caixa-editar": "editar caixa",
  "caixa-excluir": "excluir caixa",
  "grupos-tributario-cadastrar": "cadastrar grupos-tributario",
  "grupos-tributario-visualizar": "visualizar grupos-tributario",
  "grupos-tributario-editar": "editar grupos-tributario",
  "grupos-tributario-excluir": "excluir grupos-tributario",
  "operacoes-fiscais-cadastrar": "cadastrar operacoes-fiscais",
  "operacoes-fiscais-visualizar": "visualizar operacoes-fiscais",
  "operacoes-fiscais-editar": "editar operacoes-fiscais",
  "operacoes-fiscais-excluir": "excluir operacoes-fiscais",
  "modelos-tributacao-cadastrar": "cadastrar modelos-tributacao",
  "modelos-tributacao-visualizar": "visualizar modelos-tributacao",
  "modelos-tributacao-editar": "editar modelos-tributacao",
  "modelos-tributacao-excluir": "excluir modelos-tributacao",
  "grupo-tributario-modelo-tributacao-cadastrar":
    "cadastrar grupo-tributario-modelo-tributação",
  "grupo-tributario-modelo-tributacao-visualizar":
    "visualizar grupo-tributario-modelo-tributação",
  "grupo-tributario-modelo-tributacao-editar":
    "editar grupo-tributario-modelo-tributação",
  "grupo-tributario-modelo-tributacao-excluir":
    "excluir grupo-tributario-modelo-tributação",
  "nf-entrada-cadastrar": "cadastrar nf-entrada",
  "nf-entrada-visualizar": "visualizar nf-entrada",
  "nf-entrada-editar": "editar nf-entrada",
  "nf-entrada-excluir": "excluir nf-entrada",
  "orcamentos-cadastrar": "cadastrar orcamentos",
  "orcamentos-visualizar": "visualizar orcamentos",
  "orcamentos-editar": "editar orcamentos",
  "orcamentos-excluir": "excluir orcamentos",
  "pedidos-cadastrar": "cadastrar pedidos",
  "pedidos-visualizar": "visualizar pedidos",
  "pedidos-editar": "editar pedidos",
  "pedidos-excluir": "excluir pedidos",
  "nf-saida-cadastrar": "cadastrar nf-saida",
  "nf-saida-visualizar": "visualizar nf-saida",
  "nf-saida-editar": "editar nf-saida",
  "nf-saida-excluir": "excluir nf-saida",
  "contas-pagar-cadastrar": "cadastrar contas-pagar",
  "contas-pagar-visualizar": "visualizar contas-pagar",
  "contas-pagar-editar": "editar contas-pagar",
  "contas-pagar-excluir": "excluir contas-pagar",
  "contas-receber-cadastrar": "cadastrar contas-receber",
  "contas-receber-visualizar": "visualizar contas-receber",
  "contas-receber-editar": "editar contas-receber",
  "contas-receber-excluir": "excluir contas-receber",
  "documentos-frete-cadastrar": "cadastrar documentos-frete",
  "documentos-frete-visualizar": "visualizar documentos-frete",
  "documentos-frete-editar": "editar documentos-frete",
  "documentos-frete-excluir": "excluir documentos-frete",
  "saldo-inicial-cadastrar": "cadastrar saldo-inicial",
  "saldo-inicial-visualizar": "visualizar saldo-inicial",
  "saldo-inicial-editar": "editar saldo-inicial",
  "saldo-inicial-excluir": "excluir saldo-inicial",
  "pedidos-vendedor-obrigatorio": "vendedor obrigatório",
  "nf-saida-vendedor-obrigatorio": "vendedor obrigatório",
  "nf-saida-editar-desconto": "editar desconto",
  "nf-saida-preco-venda": "editar preço de venda",
  "nf-saida-vender-limite-credito-ultrapassado":
    "vender com limite de crédito ultrapassado",
  "nf-saida-vender-cliente-inadimplente": "vender para cliente inadimplente",
  "utilizar-caixa-colaborador": "utilizar caixa por colaborador",
  "pdv-vendedor-obrigatorio": "permite vendedor obrigatório",
  "limpar-carrinho": "limpar carrinho",
  "excluir-item-carrinho": "excluir item carrinho",
  dashboard: "dashboard",
  "tags-cadastrar": "cadastrar tags",
  "tags-visualizar": "visualizar tags",
  "tags-editar": "editar tags",
  "tags-excluir": "excluir tags",
  "marcas-cadastrar": "cadastrar marcas",
  "marcas-visualizar": "visualizar marcas",
  "marcas-editar": "editar marcas",
  "marcas-excluir": "excluir marcas",
  "colecoes-cadastrar": "cadastrar colecoes",
  "colecoes-visualizar": "visualizar colecoes",
  "colecoes-editar": "editar colecoes",
  "colecoes-excluir": "excluir colecoes",
  "condicionais-cadastrar": "cadastrar condicionais",
  "condicionais-visualizar": "visualizar condicionais",
  "condicionais-editar": "editar condicionais",
  "condicionais-excluir": "excluir condicionais",
  "mensagem-personalizada-cadastrar": "cadastrar mensagem-personalizada",
  "mensagem-personalizada-visualizar": "visualizar mensagem-personalizada",
  "mensagem-personalizada-editar": "editar mensagem-personalizada",
  "mensagem-personalizada-excluir": "excluir mensagem-personalizada",
  "rotas-cadastrar": "cadastrar rotas",
  "rotas-visualizar": "visualizar rotas",
  "rotas-editar": "editar rotas",
  "rotas-excluir": "excluir rotas",
  "parametros-aliquota-cadastrar": "cadastrar parametros-aliquota",
  "parametros-aliquota-visualizar": "visualizar parametros-aliquota",
  "parametros-aliquota-editar": "editar parametros-aliquota",
  "parametros-aliquota-excluir": "excluir parametros-aliquota",
  "segmentos-cadastrar": "cadastrar segmentos",
  "segmentos-visualizar": "visualizar segmentos",
  "segmentos-editar": "editar segmentos",
  "segmentos-excluir": "excluir segmentos",
  "nf-saida-enviar-documento-apos-criacao": "enviar documento após criação",
  "orcamentos-enviar-documento-apos-criacao": "enviar documento após criação",
  "pedidos-enviar-documento-apos-criacao": "enviar documento após criação",
  "condicionais-enviar-documento-apos-criacao": "enviar documento após criação",
  "transferencia-saldo-excluir": "transferência saldo excluir",
  "suprimento-excluir": "excluir suprimento",
  "sangria-excluir": "excluir sangria",
  "relatorio-condicional-resumido": "condicional resumido",
  "relatorio-nf-entrada-resumido": "nf entrada resumido",
  "relatorio-pessoas-aniversario": "aniversario pessoas",
  "relatorio-movimentacao-produtos-resumido": "movimentacao produtos resumido",
  "relatorio-movimentacao-produtos-detalhado":
    "movimentacao de produtos detalhado",
  "relatorio-inventario-estoque": "inventário estoque",
  "relatorio-estoque-financeiro": "estoque financeiro",
  "relatorio-orcamento-resumido": "orçamento resumido",
  "relatorio-pedido-resumido": "pedido resumido",
  "relatorio-nf-saida-resumido": "nf saida resumido",
  "relatorio-nf-saida-detalhado": "nf saida detalhado",
  "relatorio-comissao-vendedores": "comissão de vendedores",
  "relatorio-nf-saida-contador": "nf saida contador",
  "relatorio-contas-receber-detalhado": "contas receber detalhado",
  "relatorio-contas-pagar-detalhado": "contas pagar detalhado",
  "relatorio-caixa-diario": "caixa diario",
  "relatorio-custo-mercadoria-vendida": "custo mercadoria vendida",
  "relatorio-clientes-grade": "clientes grade",
  "relatorio-analise-produtos-vendidos": "análise de produtos vendidos",
  "relatorio-historico-pagamentos-contas-receber":
    "histórico de pagamentos contas receber",
  "nf-saida-cancelar": "nf saida cancelar",
  "pedidos-cancelar": "pedidos cancelar",
  "orcamentos-cancelar": "orçamentos cancelar",
  "tabela-custo-visualizar":
    "permite visualizar tabela de custos nos documentos de faturamento",
  "ordem-compra-visualizar":
    "permite visualizar ordem de compra nos documentos de faturamento",
  "relatorio-vendas-por-vendedor": "vendas por vendedor",
  "relatorio-cancelamento-itens": "cancelamento de itens por operador",
  "relatorio-dre-gerencial": "dre gerencial",
  "relatorio-analise-abc-clientes": "analise abc clientes",
  "relatorio-analise-abc-faturamento": "analise abc faturamento",
  "relatorio-desvio-preco-praticado": "desvio de preço praticado",
  "alteracao-preco-venda": "permite alterar preço de venda",
  "data-abertura-retroativa-ordem-servicos":
    "permite alterar a data de abertura para ordens de serviços",
  "ordem-servicos-editar-checklist": "editar o checklist da ordem de serviço",
};
